import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path d=\"M6.30033 18.9077L5.14258 17.7L10.8176 12L5.14258 6.24999L6.30033 5.04224L12.0253 10.7922L17.7003 5.04224L18.8581 6.24999L13.1831 12L18.8581 17.7L17.7003 18.9077L12.0253 13.1577L6.30033 18.9077Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol